<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t(loyalty) }}</div>
        <div class="section-subTitle my-2">Manage all Loyalty</div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button
          v-if="$can('create', 'Loyalty')"
          variant="default"
          to="add-loyalty"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->

    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(user, Userkey) in users"
        :key="Userkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $t("loyalty") }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Loyalty')"
                  v-on:click="onEditUser(user)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item v-on:click="onViewUser(user)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container" v-if="listView">
      <div class="desg-list-header">
        <div class="pr-5" style="width: 120px">{{ $tc("status", 2) }}</div>
        <div>{{ $t("loyalty") }}</div>
      </div>
      <ul class="desg-list">
        <li v-for="(user, userKey) in users" :key="userKey">
          <div class="d-flex align-items-center" style="width: 120px">
            <!-- <label class="ios-switch"> -->
            <b-form-checkbox
              :checked="user.is_active == 'Y'"
              disabled
              type="checkbox"
              class="j-checkbox"
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
            <div right variant="edit">
              <router-link
                v-if="$can('update', 'Loyalty')"
                to="edit-loyalty"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <span class="edit-pen ml-2 cursor-pointer blue-icon"></span>
              </router-link>
              <router-link to="view-loyalty" v-b-tooltip="'View'" tabindex="0">
                <span class="icon-eye ml-2 cursor-pointer blue-icon"></span>
              </router-link>
            </div>
          </div>
          <div>{{ user.username }}</div>
        </li>
      </ul>
    </div>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selected: {
        hour: 12,
        minutes: 0,
        hours_deg: 360,
        minutes_deg: 360,
      },
      gridView: false,
      listView: true,
      users: [],
      hourDial: true,
      minutesDial: false,
    };
  },
  mounted() {
    this.getUserList();
  },
  beforeMount() {
    this.getviewingnumber();
  },
  methods: {
    onFocusHour: function () {
      this.hourDial = true;
      this.minutesDial = false;
    },

    onFocusMinutes: function () {
      this.hourDial = false;
      this.minutesDial = true;
    },

    onSelectHours: function (hour, deg) {
      this.selected.hour = hour;
      this.selected.hours_deg = deg;
      setTimeout(() => {
        this.onFocusMinutes();
      }, 400);
    },

    onSelectMintue: function (mintues, deg) {
      this.selected.minutes = mintues;
      this.selected.mintues_deg = deg;
    },

    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getUserList();
      } else {
        this.currentPage = event;
        this.getUserList();
      }
    },
    getUserList: function () {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
      };
      UserService.ListAllUser({}, body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.users = data.data;
            this.rows = data.totalRows;
          } else if (
            data.status == false &&
            data.message == "You are not authorized"
          ) {
            this.$router.push({
              path: "/access-denied",
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    /* eslint-disable */
    onEditUser: function (user) {
      this.$router.push({
        path: "/user-management/edit-user",
        query: { user_id: user.user_id },
      });
    },
    onViewUser: function (user) {
      this.$router.push({
        path: "/user-management/view-user",
        query: { user_id: user.user_id },
      });
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltyComponent/loyalty.vue